module.exports = __webpack_public_path__ + "static/media/singsnap-app.1e4268c5.png";